import { Account_AccountData_account } from '../../../types/graph/Account_AccountData';
import Facebook from './Facebook';
import Instagram from './Instagram';
import LinkedIn from './LinkedIn';
import Twitter from './Twitter';

// Local imports
import { GetFeatureState } from '../../../hooks/getFeatureState';

interface Props {
  account: Account_AccountData_account;
}

const Grid: React.FC<Props> = ({ account }) => {
  const SocialNetworkFBEnabled = GetFeatureState('SocialNetworkFBFeature');
  const SocialNetworkInstagramEnabled = GetFeatureState(
    'SocialNetworkInstagramFeature'
  );
  const SocialNetworkTwitterEnabled = GetFeatureState(
    'SocialNetworkTwitterFeature'
  );
  const SocialNetworkLinkedInEnabled = GetFeatureState(
    'SocialNetworkLinkedInFeature'
  );

  return (
    <div className="rounded-lg bg-gray-200 overflow-hidden divide-y divide-gray-200 sm:divide-y-0 sm:grid sm:grid-cols-2 sm:gap-px">
      {/* Facebook */}
      {SocialNetworkFBEnabled && <Facebook account={account} />}
      {/* Instagram */}
      {SocialNetworkInstagramEnabled && <Instagram />}
      {/* Twitter */}
      {SocialNetworkTwitterEnabled && <Twitter />}
      {/* LinkedIn */}
      {SocialNetworkLinkedInEnabled && <LinkedIn />}
    </div>
  );
};

export default Grid;
